import { axios } from '../../../lib/axios';
import { Comment } from '../types';

type getCommentsOptions = {
  postId: string;
}

export const getComments = async ({ postId }: getCommentsOptions) => {
  return await axios.get<Comment[]>(`/posts/${postId}/comments`);
};